import { useMfaStatus } from '@hooks/useMfa';
import { Shield, ShieldCheck } from 'lucide-react';
import React, { useState } from 'react';

import { MfaDisableDialog } from '@/components/settings/MfaDisableDialog';
import { MfaEnrollmentDialog } from '@/components/settings/MfaEnrollmentDialog';
import { MfaRecoveryCodesDialog } from '@/components/settings/MfaRecoveryCodesDialog';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';

export function MfaSettingsSection() {
  const { data: mfaStatus, isLoading } = useMfaStatus();
  const [enrollmentOpen, setEnrollmentOpen] = useState(false);
  const [disableOpen, setDisableOpen] = useState(false);
  const [recoveryCodesOpen, setRecoveryCodesOpen] = useState(false);

  return (
    <>
      <div className="mt-6 rounded-lg border bg-card p-6">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-muted">
              {mfaStatus?.enabled ? (
                <ShieldCheck className="h-6 w-6 text-foreground" />
              ) : (
                <Shield className="h-6 w-6 text-foreground" />
              )}
            </div>
            <div>
              <h3 className="text-sm font-semibold">Two-Factor Authentication</h3>
              <p className="text-sm text-muted-foreground">
                Add an extra layer of security to your account.
              </p>
            </div>
          </div>

          {isLoading ? (
            <Skeleton className="h-10 w-48 shrink-0" />
          ) : mfaStatus?.enabled ? (
            <div className="flex items-center gap-2 shrink-0">
              <Button variant="outline" size="sm" onClick={() => setRecoveryCodesOpen(true)}>
                Recovery Codes
              </Button>
              <Button
                variant="outline"
                size="sm"
                className="border-destructive/30 text-destructive hover:bg-destructive/10 hover:text-destructive"
                onClick={() => setDisableOpen(true)}
              >
                Disable
              </Button>
            </div>
          ) : (
            <Button className="shrink-0" onClick={() => setEnrollmentOpen(true)}>
              Enable
            </Button>
          )}
        </div>
      </div>

      <MfaEnrollmentDialog open={enrollmentOpen} onOpenChange={setEnrollmentOpen} />
      <MfaDisableDialog open={disableOpen} onOpenChange={setDisableOpen} />
      <MfaRecoveryCodesDialog open={recoveryCodesOpen} onOpenChange={setRecoveryCodesOpen} />
    </>
  );
}
